import React, { useState } from "react";
import CloseIcon from "../../assets/Modal-Close-Icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";
import {
  GetAllNotification_M3,
  RecallNotification,
} from "../../../../api/notifyapi/Notifyapi";
import {
  IFilterModel,
  NotificationActions,
} from "../../../../slices/NotificationSlice";
import { Spin, Tooltip } from "antd";
import { ETableRowActionFieldApplicable } from "../../notificationPage/NotificationMangement";
import {
  LEVEL_CONSTANT,
  STATUS_CONSTANT,
} from "../CreateAndEditNotify/FormDataConstants";
import Loader from "../../loader/Loader";
import { getRecallBtnTooltip } from "../../TooltipContent/tooltipMessageHelper";

const RecallNotifications: React.FC = () => {
  const data = useSelector((state: RootState) => state.notification.editData);
  const { searchFilter } = useSelector(
    (state: RootState) => state.notification
  );
  const { user, features, switchRole } = useSelector(
    (state: RootState) => state.user
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const [isRecallButtonDisabled, setIsRecallButtonDisabled] =
    useState<boolean>(true);
  const handleClosePopup = (): void => {
    dispatch(NotificationActions.UpdateRecallAction(false));
  };

  const handleRecallNotification = (): void => {
    setIsLoading(true);
    if (data && user) {
      dispatch(
        RecallNotification({
          notificationIDs: [data.notificationID],
          performedBy: user.email,
        })
      ).then(() => {
        setIsLoading(false);
        dispatch(NotificationActions.UpdateRecallAction(false));
        if (searchFilter.globalSearch.value) {
          let lQuery: IFilterModel = {
            filters: searchFilter.globalSearchApiQuery.filters,
            isAscending: false,
            currentPageSize: searchFilter.apiQuery.currentPageSize,
            pageSize: searchFilter.apiQuery.pageSize,
            page: 1, //First time always get page 1
            isOr: true,
            isPageChanged: "",
            sortField: "",
          };

          dispatch(GetAllNotification_M3(lQuery));
        } else {
          dispatch(GetAllNotification_M3(searchFilter.apiQuery));
        }
      });
    }
  };

  // Check the button should be disabled based on user roles and notification levels
  const getRecallButtonState = (): ETableRowActionFieldApplicable => {
    // check the current status
    if (
      data?.status !== STATUS_CONSTANT.published ||
      data?.assignedUser.length === 0
    ) {
      return ETableRowActionFieldApplicable.Blur;
    }
    // check the level1 and assigneduser for recall action
    if (
      data.level === LEVEL_CONSTANT.level1 &&
      features.notification.recallNotify.level1 &&
      data?.assignedUser.toString() === user?.email
    ) {
      return ETableRowActionFieldApplicable.Show;
    }
    // check the level2 and assigneduser for reacll action
    else if (
      data.level === LEVEL_CONSTANT.level2 &&
      features.notification.recallNotify.level2 &&
      data?.assignedUser.toString() === user?.email
    ) {
      return ETableRowActionFieldApplicable.Show;
    }
    return ETableRowActionFieldApplicable.Blur;
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <div className="project-title popup-head">Recall Notification</div>
          <img
            src={CloseIcon}
            alt="close-icon"
            className="close-btn"
            tabIndex={0}
            onClick={handleClosePopup}
          />
        </div>
        <div className="delete-modal-body">
          <span>
            Are you sure you want to recall this notification? Recalling a
            notification will send it back to a ‘Recall’ state
          </span>
        </div>
        <div className="delete-modal-footer">
          <Tooltip title={getRecallBtnTooltip(data, user, switchRole)}>
            <button
              disabled={
                getRecallButtonState() === ETableRowActionFieldApplicable.Blur
                  ? true
                  : false
              }
              className={`popup-create-btn ${
                getRecallButtonState() === ETableRowActionFieldApplicable.Blur
                  ? "disabled-button-style"
                  : ""
              }`}
              onClick={() => {
                if (
                  getRecallButtonState() === ETableRowActionFieldApplicable.Show
                ) {
                  handleRecallNotification();
                }
              }}
            >
              Recall {isLoading ? <Loader /> : <></>}
            </button>
          </Tooltip>

          <button className="popup-Cancel-btn" onClick={handleClosePopup}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecallNotifications;
